@if (dataLoading()) { <app-progress></app-progress> }

<div class="page-content">
  <div class="container-fluid">

    <!-- Breadcrumb -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 class="mb-sm-0 font-size-18">{{ action().MenuTitle }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a routerLink="/admin/admin-dashboard">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">{{ action().ParentMenuTitle }}</li>
              <li class="breadcrumb-item">{{ action().MenuTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- FILTER + ADD BUTTON                                    -->
    <!-- ══════════════════════════════════════════════════════ -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <div class="row align-items-center">

              <!-- Filter Destination -->
              <div class="col-sm-4">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Filter by Destination</mat-label>
                  <mat-select name="FilterDestinationId" [(ngModel)]="FilterDestinationId"
                    (ngModelChange)="onFilterDestinationChange()">
                    <mat-option [value]="-1">-- Select Destination --</mat-option>
                    <mat-option [value]="0">-- All --</mat-option>
                    @for (dest of DestinationList(); track dest.DestinationId) {
                    <mat-option [value]="dest.DestinationId">
                      {{ dest.DestinationName }}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Add Button -->
              <div class="col-sm-8 text-sm-end pb-4 ">
                @if (action().CanCreate) {
                <button mat-raised-button color="primary" class="px-4" (click)="openModal()">
                  <!-- <i class="bx bx-plus me-1"></i> -->
                   Add/Edit Inc-Exclusion
                </button>
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════ -->
    <!-- TABLES SIDE BY SIDE                                    -->
    <!-- ══════════════════════════════════════════════════════ -->
    <div class="row g-4">

      <!-- Inclusion Table -->
      <div class="col-lg-6">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-transparent border-bottom py-3">
            <h6 class="mb-0 fw-bold text-success">
              <i class="bx bx-check-circle me-1"></i>Inclusions
            </h6>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0" style="font-size:13.5px;">
                <thead class="table-light">
                  <tr>
                    <th class="ps-3">S.No</th>
                    <th>Destination</th>
                    <th>Inclusion Details</th>
                    <!-- <th>Status</th> -->
                    @if (action().CanDelete) {
                    <th class="text-center">Delete</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (
                  item of InclusionList()
                  | filter: SearchInclusion
                  | paginate: { id: 'inclusion', itemsPerPage: itemPerPage, currentPage: pInclusion };
                  track item.InclusionId;
                  let i = $index
                  ) {
                  <tr>
                    <td class="ps-3 text-muted">
                      {{ (itemPerPage * (pInclusion - 1)) + i + 1 }}
                    </td>
                    <td>{{ item.DestinationName }}</td>
                    <td>{{ item.InclusionDetails }}</td>
                    <!-- <td>
                      <span class="badge" [class.bg-success]="item.Status === 1" [class.bg-danger]="item.Status !== 1">
                        {{ AllStatusList[item.Status] }}
                      </span>
                    </td> -->
                    @if (action().CanDelete) {
                    <td class="text-center">
                      <a class="text-danger" style="cursor:pointer" (click)="deleteInclusionFromTable(item)">
                        <i class="bx bxs-trash fs-5"></i>
                      </a>
                    </td>
                    }
                  </tr>
                  }
                  @if (InclusionList().length === 0 && !dataLoading()) {
                  <tr>
                    <td colspan="5" class="text-center text-muted py-4">
                      <i class="bx bx-list-check fs-1 d-block mb-2 opacity-25"></i>
                      No inclusions found
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="px-3 py-2">
              <pagination-controls id="inclusion" (pageChange)="pInclusion = $event" class="my-pagination"
                style="float:right;">
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>

      <!-- Exclusion Table -->
      <div class="col-lg-6">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-transparent border-bottom py-3">
            <h6 class="mb-0 fw-bold text-danger">
              <i class="bx bx-x-circle me-1"></i>Exclusions
            </h6>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0" style="font-size:13.5px;">
                <thead class="table-light">
                  <tr>
                    <th class="ps-3">S.No</th>
                    <th>Destination</th>
                    <th>Exclusion Details</th>
                    <!-- <th>Status</th> -->
                    @if (action().CanDelete) {
                    <th class="text-center">Delete</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (
                  item of ExclusionList()
                  | filter: SearchExclusion
                  | paginate: { id: 'exclusion', itemsPerPage: itemPerPage, currentPage: pExclusion };
                  track item.ExclusionId;
                  let i = $index
                  ) {
                  <tr>
                    <td class="ps-3 text-muted">
                      {{ (itemPerPage * (pExclusion - 1)) + i + 1 }}
                    </td>
                    <td>{{ item.DestinationName }}</td>
                    <td>{{ item.ExclusionDetails }}</td>
                    <!-- <td>
                      <span class="badge" [class.bg-success]="item.Status === 1" [class.bg-danger]="item.Status !== 1">
                        {{ AllStatusList[item.Status] }}
                      </span>
                    </td> -->
                    @if (action().CanDelete) {
                    <td class="text-center">
                      <a class="text-danger" style="cursor:pointer" (click)="deleteExclusionFromTable(item)">
                        <i class="bx bxs-trash fs-5"></i>
                      </a>
                    </td>
                    }
                  </tr>
                  }
                  @if (ExclusionList().length === 0 && !dataLoading()) {
                  <tr>
                    <td colspan="5" class="text-center text-muted py-4">
                      <i class="bx bx-list-minus fs-1 d-block mb-2 opacity-25"></i>
                      No exclusions found
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="px-3 py-2">
              <pagination-controls id="exclusion" (pageChange)="pExclusion = $event" class="my-pagination"
                style="float:right;">
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════ -->
<!-- MODAL                                                                  -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
@if (showModal) {
<div class="modal-backdrop fade show" style="z-index:1040; backdrop-filter:blur(4px);" (click)="closeModal()">
</div>

<div class="modal fade show d-block" style="z-index:1050;" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable custom-modal-width">
    <div class="modal-content border-0 shadow-lg">

      <!-- Header -->
      <div class="modal-header border-bottom px-4 py-3">
        <h5 class="modal-title fw-bold">
          <i class="bx bx-list-ul me-2 text-primary"></i>
          Manage Inclusions & Exclusions
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-4">

        <!-- Destination selector in modal -->
        <div class="row mb-4">
          <div class="col-sm-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Select Destination</mat-label>
              <mat-select name="ModalDestinationId" [(ngModel)]="ModalDestinationId"
                (ngModelChange)="onModalDestinationChange()">
                <mat-option [value]="0">-- Select --</mat-option>
                @for (dest of DestinationList(); track dest.DestinationId) {
                <mat-option [value]="dest.DestinationId">
                  {{ dest.DestinationName }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        @if (!ModalDestinationId || ModalDestinationId == 0) {
        <div class="text-center py-4 text-muted">
          <i class="bx bx-map-pin fs-1 d-block mb-2 opacity-25"></i>
          <p class="mb-0">Select a destination to manage inclusions and exclusions.</p>
        </div>
        }

        @if (ModalDestinationId && ModalDestinationId != 0) {
        <div class="row g-0">

          <!-- ── Inclusion ─────────────────────────────────── -->
          <div class="col-lg-6 pe-lg-4" style="border-right: 1px solid #e9ecef;">

            <h6 class="fw-bold text-success mb-1">
              <i class="bx bx-check-circle me-1"></i>Inclusions
            </h6>
            <p class="text-muted small mb-3">List of inclusions for this destination</p>

            @for (row of InclusionRows; track $index; let i = $index) {
            <div class="position-relative pe-4 mb-3">
              <div class="form-floating mb-2">
                <textarea class="form-control" style="height:70px; font-size:13.5px; resize:none;" [id]="'inc_' + i"
                  [name]="'IncDet_' + i" [(ngModel)]="InclusionRows[i].InclusionDetails" placeholder="Description"
                  maxlength="750">
                      </textarea>
                <label [for]="'inc_' + i" style="font-size:10px;">Description</label>
              </div>

              <div class="d-flex align-items-center gap-2 mb-1">
                <span class="text-muted small">Status:</span>
                @for (status of StatusList; track status.Key) {
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="'IncSt_' + i"
                    [id]="'IncSt_' + i + '_' + status.Key" [value]="status.Key" [(ngModel)]="InclusionRows[i].Status">
                  <label class="form-check-label small" [for]="'IncSt_' + i + '_' + status.Key">
                    {{ status.Value }}
                  </label>
                </div>
                }
              </div>

              <button type="button" class="btn-close position-absolute" style="top:23px; right:0; font-size:11px;"
                (click)="removeInclusionRow(i)">
              </button>
            </div>
            }

            <button type="button" class="btn btn-outline-success btn-sm mt-1" (click)="addInclusionRow()">
              <i class="bx bx-plus me-1"></i>Add More
            </button>

          </div>

          <!-- ── Exclusion ─────────────────────────────────── -->
          <div class="col-lg-6 ps-lg-4">

            <h6 class="fw-bold text-danger mb-1">
              <i class="bx bx-x-circle me-1"></i>Exclusions
            </h6>
            <p class="text-muted small mb-3">List of exclusions for this destination</p>

            @for (row of ExclusionRows; track $index; let i = $index) {
            <div class="position-relative pe-4 mb-3">
              <div class="form-floating mb-2">
                <textarea class="form-control" style="height:70px; font-size:13.5px; resize:none;" [id]="'exc_' + i"
                  [name]="'ExcDet_' + i" [(ngModel)]="ExclusionRows[i].ExclusionDetails" placeholder="Description"
                  maxlength="750">
                      </textarea>
                <label [for]="'exc_' + i" style="font-size:10px;">Description</label>
              </div>

              <div class="d-flex align-items-center gap-2 mb-1">
                <span class="text-muted small">Status:</span>
                @for (status of StatusList; track status.Key) {
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="'ExcSt_' + i"
                    [id]="'ExcSt_' + i + '_' + status.Key" [value]="status.Key" [(ngModel)]="ExclusionRows[i].Status">
                  <label class="form-check-label small" [for]="'ExcSt_' + i + '_' + status.Key">
                    {{ status.Value }}
                  </label>
                </div>
                }
              </div>

              <button type="button" class="btn-close position-absolute" style="top:23px; right:0; font-size:11px;"
                (click)="removeExclusionRow(i)">
              </button>
            </div>
            }

            <button type="button" class="btn btn-outline-danger btn-sm mt-1" (click)="addExclusionRow()">
              <i class="bx bx-plus me-1"></i>Add More
            </button>

            <p class="text-danger small mt-3 mb-0">
              <i class="bx bx-info-circle me-1"></i>
              Anything not mentioned in the inclusions is excluded.
            </p>

          </div>

        </div>
        }

      </div>

      <!-- Footer -->
      <div class="modal-footer border-top px-4 py-3">
        <p class="text-muted small me-auto mb-0">
          <i class="bx bx-info-circle me-1"></i>
          Note: Add all inclusions and exclusions then click Save Details.
        </p>
        <button type="button" class="btn btn-outline-secondary px-4" (click)="closeModal()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary px-4 fw-medium" (click)="saveAll()"
          [disabled]="!ModalDestinationId || ModalDestinationId == 0">
          <i class="bx bx-save me-1"></i> Save Details
        </button>
      </div>

    </div>
  </div>
</div>
}